import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { FrontendFeaturePlugin } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { CompanyCompleteOnboardingComponent } from './company-complete-onboarding.component';
import * as i0 from "@angular/core";
let MpfUsersFrontendManagementFeature = /*#__PURE__*/(() => {
  let MpfUsersFrontendManagementFeature = class MpfUsersFrontendManagementFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/users/frontend-management","featureId":"mpf-users"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineDynamicComponents([{
        replaceComponent: 'users-demo-subscribe',
        component: CompanyCompleteOnboardingComponent
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfUsersFrontendManagementFeature_BaseFactory;
        return function MpfUsersFrontendManagementFeature_Factory(__ngFactoryType__) {
          return (ɵMpfUsersFrontendManagementFeature_BaseFactory || (ɵMpfUsersFrontendManagementFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfUsersFrontendManagementFeature)))(__ngFactoryType__ || MpfUsersFrontendManagementFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfUsersFrontendManagementFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  };
  MpfUsersFrontendManagementFeature = __decorate([ClassName("MpfUsersFrontendManagementFeature")], MpfUsersFrontendManagementFeature);
  return MpfUsersFrontendManagementFeature;
})();
export { MpfUsersFrontendManagementFeature };